import React from 'react';

export const FlagJPIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 600" // Standard 3:2 ratio
    {...props}
  >
    <rect width="900" height="600" fill="#FFFFFF" rx="2" stroke="#D1D5DB" strokeWidth="5"/> {/* White background with subtle border */}
    <circle cx="450" cy="300" r="180" fill="#BC002D"/> {/* Red disc (3/5 of height) */}
  </svg>
);